module.exports = __webpack_public_path__ + "b9beb3bf30517f7c09edbabdee1249ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-6.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-6.jpg
// module chunks = 40